import React from 'react';
import { diseaseType } from "../../../util/varibles/constants";
import styles from "./style.module.scss";

interface IProps {
    status: any
    size?: 'small' | 'large'
}

const DiseaseStatus: React.FC<IProps> = ({ status, size = "small" }) => {
    const { name = '', color = '' } = diseaseType[status] || {};

    const style: any = { '--disease-type-color': color }
    return <div className={styles.status} data-code={status} data-size={size} style={style} title={name}>
        {name}
    </div>;
};

export default DiseaseStatus;